import { autoinject, customAttribute, TaskQueue } from 'aurelia-framework'
import { SecurityService } from "../../services/security-service";

@customAttribute('security-role')
@autoinject()
export class SecurityRole {
    constructor(private element: Element, private taskQueue: TaskQueue,
        private securityService: SecurityService) {
    }

    attached() {
        this.taskQueue.queueTask(() => {
            let role = this["value"];
            if (!this.securityService.hasRole(role)) {
                if (!(<any>this.element).style) {
                    debugger;
                }
                (<any>this.element).style.display = "none";
            }
        });
    }

}